/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';
import colonIcon from '../../../../../../assets/sme/component/colon_icon.png';
export interface IDataSourceItem {
  label: string;
  link?: string;
}

export interface IRealCaseContentProps {
  headingLines?: string[];
  descTitle?: string;
  overviewList?: string[];
  dataSource?: string;
  dataSourceList?: IDataSourceItem[];
  backgroundImage?: string;
}

const RealCaseContent: React.FunctionComponent<IRealCaseContentProps> = ({
  headingLines,
  descTitle,
  overviewList,
  dataSource,
  dataSourceList,
  backgroundImage,
}) => (
  <div className="real-case-content">
    <div className="real-case-content-header">
      <div className="real-case-content-header-text">
        <img src={colonIcon} alt="" className="colon-icon" />
        {headingLines?.length ? (
          <h2 className="real-case-content-heading">
            {headingLines.map((line, index) => (
              <span key={index}>{line}</span>
            ))}
          </h2>
        ) : null}
      </div>
      {backgroundImage ? (
        <img
          className="real-case-content-header-img"
          src={backgroundImage}
          alt=""
        />
      ) : null}
    </div>
    <div className="real-case-content-card">
      {descTitle ? (
        <span className="real-case-content-tag">{descTitle}</span>
      ) : null}
      <div className="real-case-content-body">
        {overviewList?.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
      {(dataSource || dataSourceList?.length) && (
        <div className="real-case-content-footer">
          <div className="real-case-content-footer-line" />
          <div className="real-case-content-source">
            {dataSource}
            {dataSourceList?.map((item, index) =>
              item.link ? (
                <a
                  key={index}
                  className="real-case-content-link"
                  target="_blank"
                  rel="noreferrer"
                  href={item.link.trim()}
                >
                  {item.label}
                </a>
              ) : (
                <span key={index} className="real-case-content-link">
                  {item.label}
                </span>
              )
            )}
          </div>
        </div>
      )}
    </div>
  </div>
);

export default React.memo(RealCaseContent);
